import { useState } from "react";
import { LayoutGroup } from "framer-motion";
import { projects } from "../data/projects";
import { PortfolioCard } from "./PortfolioCard";
import { PortfolioModal } from "./PortfolioModal";

export const Portfolio = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="relative">
      {/* Grid */}
      <LayoutGroup>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border-l border-t border-divider">
          {projects.map((p, i) => (
            <PortfolioCard
              key={p.id}
              project={p}
              index={i}
              onOpen={setActive}
            />
          ))}
        </div>

        <PortfolioModal project={active} onClose={() => setActive(null)} />
      </LayoutGroup>
    </section>
  );
};
